import React,{ Component } from 'react';
import {Link} from 'react-router';
import $ from 'jquery';
import Web_NotFound from './../Common/Web_NotFound.js';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';
// path is /status/:book_id/:type

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class Order_response extends Component{
	constructor(props){
		super(props);
		this.state={
			response_data:[],
			page_error_status:false,
			payment_details:[],
			visibility:false,			
		}
		this.getOrderDetails=this.getOrderDetails.bind(this);
	}
	componentDidMount()
	{
		window.scrollTo(0, 0);		
		if(screen.width < 800)
		{
		    window.location.href="/status/"+this.props.params.book_id+'/'+this.props.params.type+'/'+this.props.params.Uid;
		}
		this.getOrderDetails();
	}
	getOrderDetails()
	{
		if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
		if(localStorage.user_id)
	    {
	    	var uid=localStorage.user_id;
	    }
	    else
	    {
	    	uid=0;
	    }
		var data1={from:'desktop_web',user_id:uid,token:localStorage.token,type:this.props.params.type,book_id:this.props.params.book_id,uid:this.props.params.Uid,source:source,campaign:campaign,url_id:url_id};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'get_order_responce',
			success:function(data)
			{
				if(data.status==="success")
				{
					this.setState({
						response_data:data,
						payment_details:data.payment_details,
						disclaimer_flag:data.disclaimer_flag
					});
					localStorage.removeItem('source');
					localStorage.removeItem('campaign');
					localStorage.removeItem('url_id');
				}
				else
				{
					this.setState({
						page_error_status:true,
					});
				}
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	toggleDisclaimer(){
		    this.setState({visibility:!this.state.visibility});
	}		
	render(){
		return(
			<div className="web_deals web_order_success_page">
			     {this.state.page_error_status ? <Web_NotFound /> :
			    	<div className="web_order_success_page">
			    	<WebHeaderInner />
				    <div className="clr">&nbsp;</div>	
				    <div className="clr">&nbsp;</div>
				    <div className="clr">&nbsp;</div>
				    <div className="clr">&nbsp;</div>
				    <div className="clr">&nbsp;</div>
				    <div className="clr">&nbsp;</div>
					<section className="container">
				    	<div className="row">
				    	<div className="col-md-6 col-md-offset-3">
			    <div className="response_content">
			    	<div style={{textAlign:'center',padding:'45px 0px 30px 0'}}>
			  			<i><img style={{paddingBottom:'35px;'}} src={require('./../../../assets/images/checkmark.png')} width="60" alt="..."></img></i>
			  			<h5 style={{fontWeight:800}}>{this.state.response_data.success_msg}</h5>
			  			<h6>{this.state.response_data.thank_msg}</h6>
			  		</div>
		  			<section className="order_deatails_blk">
		  			<div></div>
		  			<div className="order_deatails_card">
		  				<h5>ORDER DETAILS</h5>
		  				<h5><span>Order No</span><span style={{float:'right'}}>Order Date</span></h5>
						<h5><span>{this.state.response_data.book_id}</span><span style={{float:'right'}}>{this.state.response_data.booking_date ? this.state.response_data.booking_date : ''}</span></h5>
		  				<h5><span>Amount Paid (Online)</span><span style={{float:'right',fontWeight:800}}>&#8377; {this.state.response_data.total_online_payment}</span></h5>														
		  			</div>	
		  			<div className="rate_us_block">
		  				<ul>
		  					<li>
		  						<div className="rate_img_block">
		  							<img className="img-responsive" src={require('./../../../assets/images/rateus_icn.png')}  alt="..." />
		  						</div>
				  				<div className="rate_content">
				  					<h4>Love the App?</h4>
				  					<h6>Please take a moment to rate us,Your feedback is very important...</h6>
				  				</div>		  						
				  				<a href="https://goo.gl/gvP4pb"><button>Rate Now</button></a>				  				
		  					</li>
		  					<li>
		  						<div className="rate_img_block">
		  							<img className="img-responsive" src={require('./../../../assets/images/ref_earn_icn.png')}  alt="..." />
		  						</div>
				  				<div className="rate_content">
				  					<h4>Share & Earn</h4>
				  					<h6>Invite your friends to AquaDeals and you both earn rewards. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h6>
				  				</div>
				  				<a href={'/share_earn'}><button>Share Now</button></a>		  						
		  					</li>
		  				</ul>																					
		  			</div>
		  			<div className="conffirm_page_buttom_btns">
		  				<ul>
		  					<li><a href={'/'}><button>CONTINUE SHOPPING</button></a></li>
		  					<li><a href={'/order_details/'+this.state.response_data.type+'/'+this.state.response_data.bid}><button>REVIEW ORDER</button></a></li>
		  				</ul>
		  			</div>
					{this.state.disclaimer_flag ?
			  			<div className="view_disclaimer_details">
			  				<span id="disclaimer_toggle_txt"><a onClick={()=>{this.toggleDisclaimer()}}>{this.state.visibility ? "Hide Disclaimer" : "View Disclaimer"}</a></span>
			  				{this.state.visibility ? <span id="mob_disclaimer_txt" dangerouslySetInnerHTML={{ __html: this.state.response_data.disclaimer_txt}}></span> : ''}
			  			</div> : ''		  					  			
		  			}		  					  			
		  			</section>			

			    </div> 
					    	</div>
					    </div> 
				    </section>
				    <WebFooter />
				    </div>
			    }
			</div>
		);
	}
}




/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Cart/Web_Order_response.js
 **/